/** @module csi/widget/TabContainer */
define([
	"dojo/_base/declare",
	"dijit/layout/TabContainer",
	"csi/html"
], function(declare, TabContainer, html) {

	return declare(TabContainer, {
		/**
		 * Hides a tab
		 * @param {dijit/_WidgetBase} tab
		 */
		hideChild: function(tab) {
			// If this tab is the selected one, find another tab to select
			if (tab.selected) {
				var children = this.getChildren();
				for (var key in children) {
					var child = children[key];

					if (child != tab) {
						this.selectChild(child);
						break;
					}
				}
			}

			html.setVisible(tab.domNode, false);
			html.setVisible(tab.controlButton.domNode, false);
			this._hideChild(tab);
		},

		showChild: function(tab) {
			html.setVisible(tab.domNode, true);
			html.setVisible(tab.controlButton.domNode, true);
		}
	});
});